import React, { forwardRef, useMemo, ReactElement } from 'react';
import { IconBase, IconWeight } from '@phosphor-icons/react'; // eslint-disable-line no-restricted-imports

type CustomIconBaseProps = {
  paths: ReactElement;
  size?: number;
  color?: string;
  weight?: IconWeight;
  mirrored?: boolean;
} & React.SVGProps<SVGSVGElement>;

const CustomIconBase = forwardRef<SVGSVGElement, CustomIconBaseProps>(
  ({ paths, ...props }, ref) => {
    // 🔹 build the weights map correctly
    const weights = useMemo<Map<IconWeight, React.ReactElement>>(
      () =>
        new Map([
          ['thin', paths],
          ['light', paths],
          ['regular', paths],
          ['bold', paths],
          ['fill', paths],
          ['duotone', paths],
        ]),
      [paths],
    );

    return <IconBase ref={ref} {...props} weights={weights} />;
  },
);

CustomIconBase.displayName = 'CustomIconBase';

export default CustomIconBase;
